import React, { useEffect, useState } from "react";
import { api } from "@/api/client";
import TopBar from "@/components/TopBar";
import { useAuth } from "@/context/AuthContext";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const now = new Date();

const safe = (s) => String(s || "").replace(/[\\/"\r\n\t]/g, "").trim().replace(/\s+/g, "_") || "unknown";

export default function DriverReports() {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const nav = useNavigate();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [reportType, setReportType] = useState("both");
  const [includeStatus, setIncludeStatus] = useState("approved");
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (user?.employee_id) {
      api.get("/employees/me/profile").then((r) => setProfile(r.data)).catch(() => {});
    }
  }, [user]);

  const lang = i18n.language === "en" ? "en" : "ja";
  const monthStr = String(month).padStart(2, "0");
  const fnameBase = profile
    ? `${safe(profile.employee_code)}-${safe(profile.name)}-${year}${monthStr}`
    : `report-${year}${monthStr}`;

  const download = async (fmt) => {
    const empId = user?.employee_id;
    if (!empId) return alert(lang === "en" ? "No employee link" : "従業員リンクがありません");
    const path = `/reports/employee/${empId}/${fmt}?year=${year}&month=${month}&report_type=${reportType}&lang=${lang}&include_status=${includeStatus}`;
    try {
      const res = await api.get(path, { responseType: "blob" });
      const mime = res.headers?.["content-type"] || "application/octet-stream";
      const blob = new Blob([res.data], { type: mime });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${fnameBase}.${fmt === "excel" ? "xlsx" : "pdf"}`;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 1500);
    } catch (e) {
      alert("ダウンロードに失敗しました: " + (e.response?.status || e.message));
    }
  };

  return (
    <div className="shell">
      <TopBar />
      <div className="container" style={{ maxWidth: 640 }}>
        <button className="btn btn-outline" onClick={() => nav(-1)} style={{ marginBottom: 12 }}>← {t("common.back")}</button>
        <h1 className="page-title">{t("driver.downloadReport")}</h1>
        <div className="card"><div className="card-body">
          <div className="grid grid-2">
            <div className="field"><label className="label">{t("common.year")}</label>
              <input className="input" type="number" value={year} onChange={(e) => setYear(Number(e.target.value))} data-testid="rep-year" />
            </div>
            <div className="field"><label className="label">{t("common.month")}</label>
              <select className="select" value={month} onChange={(e) => setMonth(Number(e.target.value))} data-testid="rep-month">
                {Array.from({length: 12}, (_, i) => <option key={i+1} value={i+1}>{lang === "en" ? `${i+1}` : `${i+1}月`}</option>)}
              </select>
            </div>
          </div>
          <div className="field">
            <label className="label">{t("admin.reportType")}</label>
            <select className="select" value={reportType} onChange={(e) => setReportType(e.target.value)} data-testid="rep-type">
              <option value="both">{t("admin.reportBoth")}</option>
              <option value="attendance">{t("admin.reportAttendance")}</option>
              <option value="expense">{t("admin.reportExpense")}</option>
            </select>
          </div>
          <div className="field">
            <label className="label">{t("common.includeStatus")}</label>
            <select className="select" value={includeStatus} onChange={(e) => setIncludeStatus(e.target.value)} data-testid="rep-include-status">
              <option value="approved">{t("common.statusApprovedOnly")}</option>
              <option value="approved_submitted">{t("common.statusApprovedSubmitted")}</option>
            </select>
          </div>
          <div className="row-actions">
            <button className="btn btn-primary" onClick={() => download("excel")} data-testid="rep-excel">Excel</button>
            <button className="btn btn-outline" onClick={() => download("pdf")} data-testid="rep-pdf">PDF</button>
          </div>
        </div></div>
      </div>
    </div>
  );
}
